import { render, staticRenderFns } from "./CurrentShipments.vue?vue&type=template&id=918e9b0c&scoped=true&"
import script from "./CurrentShipments.vue?vue&type=script&lang=js&"
export * from "./CurrentShipments.vue?vue&type=script&lang=js&"
import style0 from "./CurrentShipments.vue?vue&type=style&index=0&id=918e9b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918e9b0c",
  null
  
)

export default component.exports